import { Module } from 'vuex'
import { actions } from './actions'
import { mutations } from './mutations'
import { state } from './state'
import { NoteAction, NoteMutation, NoteState } from './types'

const namespaced: boolean = true
export const note: Module<NoteState,any> = {
  namespaced,
  state,
  actions,
  mutations,
}

export const types = {
  action:  NoteAction,
  mutation: NoteMutation,
}

export const domain = 'note'

export const vuexModule = {
  [domain]: note,
}